<template>
  <div>
    <div class="overflow-hidden flex justify-center">
      <div v-if="step == 0">
        <div class="head m-b-6">
          <h2 style="margin-bottom: 13px">شماره موبایل</h2>
          <p>لطفا شماره تلفن خود را وارد کنید.</p>
          <p>مابرای تایید حساب شما کد 5 رقمی ارسال خواهیم کرد</p>
        </div>
        <div class="items-center m-b-6">
          <div class="n-wprenumber mx-auto max-w-screen-xl m-b-126">
            <input
              type="number"
              class="main-input"
              v-model="cofermCodeData.mobile"
              autofocus
            />
            <div class="prenumber">+98</div>
          </div>
        </div>
        <button
          class="m-btn"
          @click="sendNumberHandler"
          :disabled="cofermCodeData.mobile == null"
        >
          ارسال کد
        </button>
      </div>
      <div v-if="step == 1">
        <div class="head">
          <h2 style="margin-bottom: 13px">تایید حساب</h2>
          <p>کد 5 رقمی تایید را که به شماره .</p>
          {{ cofermCodeData.mobile }}
          <p>ارسال کرده‌ایم، وارد کنید.</p>
        </div>
        <div class="items-center">
          <input
            class="dash-input"
            v-model="cofermCodeData.code"
            maxlength="5"
            autofocus
          />
        </div>
        <div class="resendSection">
          <span>{{ remainingTime }}</span>
          <p>کد را دریافت نکردید؟</p>
          <div class="p-link" @click="reSendHandler" :disabled="!timeExpired">
            ارسال دوباره
          </div>
          <div class="p-link" @click="reEnterNumber">اصلاح</div>
        </div>
        <button class="m-btn confer-btn" @click="cofermCodeHandler">
          تایید
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    remainingTime() {
      var sec = this.remainingTimeSec;
      var m = Math.floor((sec % 3600) / 60);
      var s = Math.floor((sec % 3600) % 60);
      return ` ${m} : ${s} `;
    },
    timeExpired() {
      return this.remainingTimeSec == 0;
    },
  },
  mounted() {
    this.findIp();
    this.getOS();
  },
  data() {
    return {
      remainingTimeSec: 120,
      step: 0,
      cofermCodeData: {
        type: "Web",
        hardware_id: "1",
        ip: null,
        brand: "brand",
        model: "Web",
        os: null,
        os_version: "0.1",
        mobile: null,
        code: null,
      },
    };
  },
  methods: {
    getOS() {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
        windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
        iosPlatforms = ["iPhone", "iPad", "iPod"],
        os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = "Mac OS";
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = "Windows";
      } else if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
      }

      this.cofermCodeData.os = os;
    },
    setTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.remainingTimeSec = 120;
      this.intervalId = setInterval(() => {
        this.remainingTimeSec--;
        if (this.remainingTimeSec == 0) {
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    sendNumberHandler() {
      var registerData = {
        mobile: this.cofermCodeData.mobile,
      };
      this.$store
        .dispatch("user/sendNumber", registerData)
        .then(() => {
          this.step++;
          this.setTimer();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reSendHandler() {
      var registerData = {
        mobile: this.mobilNumber,
      };
      this.$store.dispatch("user/sendNumber", registerData).then(() => {
        this.setTimer();
      });
    },
    reEnterNumber() {
      this.step--;
    },
    findIp() {
      //       const headers = { "Access-Control-Allow-Origin": "",
      // "Content-Type": "application/json",
      // "charset": "utf-8" };
      //       fetch("https://ipinfo.bfst.ir/json", {headers})
      //         .then((x) => x.json())
      //         .then(({ ipAddress }) => {
      //           this.cofermCodeData.ip = ipAddress;
      //         })
      this.cofermCodeData.ip = "192.168.1.1";
    },
    cofermCodeHandler() {
      this.$store
        .dispatch("user/confermCode", this.cofermCodeData)
        .then((rsp) => {
          localStorage.setItem("token", rsp.token);
          this.$store.commit("user/setToken", rsp.token);
          this.$router.push({ name: "Home" });
        });
      this.confermCode = null;
    },
  },
};
</script>

<style scoped>
.d-n {
  display: none;
}
.confer-btn {
  margin-left: -43px;
  width: 132%;
  margin-top: 32px;
}
.dash-input {
  display: block;
  margin: 2em auto;
  border: none;
  padding: 0;
  width: 9.5ch;
  background: repeating-linear-gradient(
      90deg,
      dimgrey 0,
      dimgrey 1ch,
      transparent 0,
      transparent 1.9ch
    )
    0 100%/ 9ch 2px no-repeat;
  font: 5ch droid sans mono, consolas, monospace;
  letter-spacing: 0.9ch;
}
.dash-input:focus {
  outline: none;
  color: dodgerblue;
}
</style>
